import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import qs from '../../../../utils/qs';
import { useSessionStorage } from './../../../../components/SessionStorageContext';

const useRouteQuery = () => {
  const router = useRouter();
  const [pathname, search] = router.asPath.split('?');
  const query = qs.parse(search);

  const updateRouteQuery = (newData: object, reset = false) =>
    router.replace(
      {
        pathname,
        search: qs.stringify({
          ...(!reset && { ...query }),
          ...newData,
        }),
      },
      undefined,
      { shallow: true },
    );

  const routeQuery = (field: string) =>
    router?.query && router.query && router.query[field];

  return {
    routeQuery,
    updateRouteQuery,
  };
};

const useAirport = ({
  parameterName,
  onChange,
}: {
  parameterName: string;
  onChange?: Function;
}) => {
  const { updateRouteQuery, routeQuery } = useRouteQuery();
  const { searchParams, setSearchParams } = useSessionStorage();
  const queryStringValue = routeQuery(parameterName) as string;
  const storageValue = searchParams && searchParams[parameterName];
  const [value, setValue] = useState<string | undefined>(storageValue);

  useEffect(() => {
    if (queryStringValue && queryStringValue !== value) {
      setValue(queryStringValue);
      setSearchParams({ [parameterName]: queryStringValue });
      onChange?.(queryStringValue);
    }
  }, [onChange, parameterName, queryStringValue, setSearchParams, value]);

  const set = (value: string) => {
    setValue(value);
    onChange?.(value);
    setSearchParams({ [parameterName]: value });
    updateRouteQuery({ [parameterName]: value });
  };

  return {
    value,
    setValue: set,
  };
};

export default useAirport;
